import { render, staticRenderFns } from "./ensureEmail.vue?vue&type=template&id=a061a778"
import script from "./ensureEmail.vue?vue&type=script&lang=js"
export * from "./ensureEmail.vue?vue&type=script&lang=js"
import style0 from "./ensureEmail.vue?vue&type=style&index=0&id=a061a778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports